// extracted by mini-css-extract-plugin
export var bodySections = "_5h-8";
export var gray = "_5h-7";
export var green = "_5h-4";
export var iconContainer = "_5h-9";
export var iconWidgetContainer = "_5h-1";
export var phoneIcon = "_5h-2";
export var red = "_5h-5";
export var statusDot = "_5h-3";
export var widgetContainer = "_5h-0";
export var yellow = "_5h-6";